// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1c50C","productName":"Table_productName__1JDwc"};